import React from "react";
import IMAGE_ASTRO from "../assets/images/astronaut-orange.jpg";
import { Button, Checkbox, Form, Input, Modal } from "antd";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useLoginServiceMutation } from "../services/PortfolioSerivce/PortfolioService";
import middlewareAuthenticator from "../utils/middlewareAuthenticator";

const LoginPage = () => {
  const [loginAdmin, result_login] = useLoginServiceMutation();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const onFinish = async (values: any) => {
    try {
      const result = await loginAdmin(values).unwrap();

      if (result.status === 200) {
        // Check path before redirect
        const url = params.get("url");
        if (url) {
          navigate(`${url}`);
        } else {
          navigate("/back-admin");
        }
      } else if (result.status === 400 || 404) {
        Modal.error({
          title: "เกิดข้อผิดพลาด ! ",
          content: "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง",
        });
      }
    } catch (error) {
      Modal.error({
        title: "เกิดข้อผิดพลาด ! ",
        content: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
      });
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-[100dvh]">
      <div className="bg-custom-primary-50 h-[400px] max-w-[600px] w-full rounded-[20px] flex overflow-hidden sm:flex-col ">
        <div className="w-[50%] sm:w-full sm:h-[100px]">
          <img
            src={IMAGE_ASTRO}
            className="h-full w-full object-cover sm:object-top"
          />
        </div>
        <div className="w-[50%] p-[20px] flex flex-col justify-center h-full sm:w-full">
          <Form
            name="basic"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
          >
            {/* input  username*/}
            <Form.Item
              name="user_name"
              required={false}
              rules={[
                {
                  required: true,
                  message: "Enter user",
                },
              ]}
            >
              <Input allowClear />
            </Form.Item>

            {/* input  password*/}
            <Form.Item
              name="password"
              required={false}
              rules={[
                {
                  required: true,
                  message: "Enter password",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>

            {/* button */}
            <Form.Item className="justify-start flex">
              <Button
                type="primary"
                htmlType="submit"
                className="!bg-custom-secondary-75 w-[100px] hover:!bg-custom-primary-100 text-custom-primary-100"
                loading={result_login.isLoading}
              >
                LOGIN
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default middlewareAuthenticator(LoginPage, {
  pageAction: "NOT_USE_AUTH",
});
